<template>
  <div>
    <apexchart type="bar" :options="chartOptions" :series="chartSeries" />
  </div>
</template>

<script>
import ApexCharts from "vue3-apexcharts";

export default {
  components: {
    apexchart: ApexCharts,
  },
  props: {
    allData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [],
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
      },
      chartSeries: [
        {
          name: "Ventes",
          data: [],
          color: "#3D2FAD",
        },
      ],
    };
  },
  created() {
    this.updateChartData();
  },
  watch: {
    allData: {
      handler() {
        this.updateChartData();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    updateChartData() {
      this.chartOptions.xaxis.categories = this.allData.map(
        (item) => item.name
      );
      this.chartSeries[0].data = this.allData.map((item) => item.value);
    },
  },
};
</script>

<style scoped>
/* Ajoutez des styles si nécessaire */
</style>
